import { H2RInput } from "../../imports";
import {
	ReplaceWithDataSource,
} from "../helpers/variable";
import { H2RButton } from "../../imports";
import { faCheck, faClose, faPlus } from "@fortawesome/free-solid-svg-icons";

export const GraphicEditor = ({ cue, media, onUpdate }) => {
	return (
		<>
			<H2RInput
				label="Title (Large text)"
				value={cue.title}
				onChange={(value) => {
					onUpdate({
						title: value,
					});
				}}
			/>
			{cue.items.length < 1 && (
				<span className="mt-6 text-gray-600 text-sm">
					No ticker items added
				</span>
			)}
			{cue.items.map((item, index) => {
				return (
					<div key={`${index}_${cue.items.length + 1}`}>
						<div className="pt-2 flex items-end space-x-2">
							<H2RButton
								text=""
								icon={faCheck}
								size="small"
								css="w-min"
								colour={item.checked ? "light" : "dark"}
								onClick={() => {
									// let newArray = Array.from(cue.items);

									// newArray[index].checked = !newArray[index].checked || true;

									// // return console.log(index, newArray);
									// return onUpdate({ items: [...newArray] });

									return onUpdate({
										items: [
											...cue.items.map((it, id) => {
												if (id === index) {
													return {
														...it,
														checked: !it.checked,
													};
												} else {
													return {
														...it,
													};
												}
											}),
										],
									});
								}}
							/>
							<H2RInput
								label={`Item ${index + 1} (Small text)`}
								value={item.body}
								onChange={(value) => {
									let val = value;
									return onUpdate({
										items: [
											...cue.items.map((it, id) => {
												if (id === index) {
													return {
														...it,
														body: val,
													};
												} else {
													return {
														...it,
														body: it.body,
													};
												}
											}),
										],
									});
								}}
							/>
							<H2RButton
								type="link"
								text=""
								icon={faClose}
								size="small"
								css="w-min"
								colour="dark"
								onClick={() => {
									let newArray = Array.from(cue.items);

									newArray.splice(index, 1);

									// return console.log(index, newArray);
									return onUpdate({ items: [...newArray] });
								}}
							/>
						</div>
					</div>
				);
			})}
			<H2RButton
				text="Add item"
				icon={faPlus}
				size="small"
				colour="dark"
				onClick={() => {
					return onUpdate({
						items: [
							...cue.items,
							{
								title: "Item",
								body: "Body text",
							},
						],
					});
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg  overflow-hidden">
			<span className="font-semibold">
				{<ReplaceWithDataSource text={cue.title} keepBrakets={true} styled={true} /> ||
					"Checklist title"}
			</span>
		</div>
	);
};
